import CandidatureAddRequest, {
  CandidatureAddRequestCandidatureEntryType,
} from "../../../api/raily/candidature/add/candidature-add.request";
import CandidatureDeleteOrderParams from "./candidature-delete-order-params";

const create = (
  params: CandidatureDeleteOrderParams,
): CandidatureAddRequest => {
  return {
    driverId: params.driverUuid,
    acceptImmediately: true,
    candidatureEntries: [
      {
        candidateEntryType:
          CandidatureAddRequestCandidatureEntryType.DELETE_SOLVED_ORDER,
        deleteTargetId: params.solvedOrderUuid,
      },
    ],
  };
};

const candidatureDeleteOrderParamsFactory = {
  create,
};

export default candidatureDeleteOrderParamsFactory;
